<h1 class="text-dark text-xl" mat-dialog-title>Carica Documenti Multipli</h1>
<div class="w-full" mat-dialog-content>
  <app-multiple-document-form
    [data]="data"
    [triggerProgressBar]="triggerProgressBar"
  ></app-multiple-document-form>
</div>
<app-progress-bar *ngIf="showProgressBar" [progress]="progress"></app-progress-bar>
